/**
 * Route paths for the accounting firm feature. The same strings are the sidebar
 * menu keys in `useMenuAccountingFirm`, so they must stay absolute: the detail
 * view runs `matchPath` and `generatePath` against them.
 */
export const ACCOUNTING_FIRM_ROUTES = {
  accountingFirms: "/accounting-firms",
  add: "/accounting-firms/add",
  accountingFirmDetail: "/accounting-firms/:accountingFirmId",
  info: "/accounting-firms/:accountingFirmId/info",
  banks: "/accounting-firms/:accountingFirmId/banks",
  address: "/accounting-firms/:accountingFirmId/address",
  contacts: "/accounting-firms/:accountingFirmId/contacts",
  platform: "/accounting-firms/:accountingFirmId/platform",
  addons: "/accounting-firms/:accountingFirmId/addons",
  companies: "/accounting-firms/:accountingFirmId/companies",
  settings: "/accounting-firms/:accountingFirmId/settings",
  settingsGeneral: "/accounting-firms/:accountingFirmId/settings/general",
  settingsPaymentMethods: "/accounting-firms/:accountingFirmId/settings/payment-methods",
  settingsExpensesCategories: "/accounting-firms/:accountingFirmId/settings/expenses-categories",
  settingsCustomGraphics: "/accounting-firms/:accountingFirmId/settings/custom-graphics",
  settingsCounterpartSsiRules: "/accounting-firms/:accountingFirmId/settings/counterpart-ssi-rules",
} as const;
